type TimeEntryDialogFormData = {
  client_number?: unknown
  matter_number?: unknown
  start?: unknown
  stop?: unknown
  duration?: unknown
  description?: unknown
  mycase_activity?: unknown
  activity_code?: unknown
  task_code?: unknown
}

type TimeEntryDialogReadyOptions = {
  matterUtbmsRequired?: boolean | null
  isMyCaseBilling?: boolean
  allowDeriveStop?: boolean
}

const narrativeOcgContextFields = new Set([
  'client_id',
  'client_number',
])

const hasText = (value: unknown) =>
  typeof value === 'string' ? value.trim().length > 0 : Boolean(value)

const hasValidDate = (value: unknown): value is Date =>
  value instanceof Date && !Number.isNaN(value.getTime())

const hasPositiveDuration = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value > 0

export const deriveTimeEntryStop = (start: unknown, duration: unknown) => {
  if (!hasValidDate(start) || !hasPositiveDuration(duration)) return null

  const stop = new Date(start.getTime() + duration * 60 * 60 * 1000)
  return hasValidDate(stop) ? stop : null
}

export const isTimeEntryDialogFormReady = (
  data: TimeEntryDialogFormData,
  {
    matterUtbmsRequired = false,
    isMyCaseBilling = false,
    allowDeriveStop = false,
  }: TimeEntryDialogReadyOptions = {}
) => {
  const hasStart = hasValidDate(data.start)
  const hasDuration = hasPositiveDuration(data.duration)
  const hasStop = hasValidDate(data.stop) || (allowDeriveStop && hasStart && hasDuration)

  if (!hasText(data.client_number)) return false
  if (!hasText(data.matter_number)) return false
  if (!hasStart) return false
  if (!hasStop) return false
  if (!hasDuration) return false
  if (!hasText(data.description)) return false
  if (isMyCaseBilling && !hasText(data.mycase_activity)) return false
  if (matterUtbmsRequired && !data.activity_code) return false
  if (matterUtbmsRequired && !data.task_code) return false

  return true
}

export const isNarrativeOcgContextField = (field: unknown) =>
  typeof field === 'string' && narrativeOcgContextFields.has(field)

export const hasNarrativeOcgClientContext = (data: {
  client_id?: unknown
  client_number?: unknown
}) =>
  (data.client_id !== null &&
    data.client_id !== undefined &&
    String(data.client_id).trim().length > 0) ||
  hasText(data.client_number)

const normalizeSuggestedNarrative = (value: unknown) => {
  const text = typeof value === 'string' ? value.trim() : ''
  if (!text) return ''
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const isSameSuggestedNarrative = (current: unknown, original: unknown) =>
  normalizeSuggestedNarrative(current) === normalizeSuggestedNarrative(original)

export const shouldSkipSuggestedNarrativeRecheck = (
  currentNarrative: unknown,
  lastValidatedNarrative: unknown
) => isSameSuggestedNarrative(currentNarrative, lastValidatedNarrative)
